import React, { useMemo } from 'react';
import PlayingCard from './PlayingCard';
import TrickCardSprite from './TrickCardSprite';
import { isNarrowMobileLayout } from '../utils/handLayout';
import { TRICK_GATHER_MS } from '../utils/trickAnimation';

const PC_CARD_W = 78;
const PC_CARD_H = 108;

/**
 * Center / trick card layout.
 * On mobile, card size matches the metrics passed in (should be south/own hand size).
 */
export function centerLayout(handMetrics, { matchHandSize = false } = {}) {
  const mobile = matchHandSize || isNarrowMobileLayout();
  if (!mobile) {
    const trickDist = PC_CARD_H * 0.5;
    const handReach = 112;
    return {
      cardW: PC_CARD_W,
      cardH: PC_CARD_H,
      trickDist,
      handReach,
      dealFlyDist: 96,
    };
  }
  /* Phone: match south hand card size exactly */
  const cardW = handMetrics?.w || 69;
  const cardH = handMetrics?.h || 96;
  const trickDist = Math.round(cardH * 0.48);
  const handReach = Math.round(cardH * 1.05);
  const dealFlyDist = Math.round(cardH * 0.92);
  return { cardW, cardH, trickDist, handReach, dealFlyDist };
}

function SpadesCenter({
  title,
  settings,
  isHost,
  gamePlaying,
  game,
  handMetrics,
  matchHandSize = false,
  dealFlash,
  trickCards = [],
  onFlyComplete,
  onGatherComplete,
}) {
  const layout = useMemo(
    () => centerLayout(handMetrics, { matchHandSize }),
    [handMetrics, matchHandSize],
  );
  const { cardW, cardH, trickDist, handReach, dealFlyDist } = layout;
  const showDeck = !gamePlaying || !game || game.showDeck;

  return (
    <div
      className="spades-center"
      style={{
        '--deal-fly-dist': `${dealFlyDist}px`,
        '--center-card-w': `${cardW}px`,
        '--center-card-h': `${cardH}px`,
        '--trick-gather-ms': `${TRICK_GATHER_MS}ms`,
      }}
    >
      {showDeck && (
        <div
          className="spades-deck"
          style={{ width: `${cardW}px`, height: `${cardH}px` }}
          aria-hidden="true"
        >
          <PlayingCard faceDown width={cardW} height={cardH} className="spades-deck-card spades-deck-card--back" />
          <PlayingCard faceDown width={cardW} height={cardH} className="spades-deck-card spades-deck-card--mid" />
          <PlayingCard faceDown width={cardW} height={cardH} className="spades-deck-card spades-deck-card--top" />
        </div>
      )}

      {dealFlash && (
        <PlayingCard
          faceDown
          width={cardW}
          height={cardH}
          className={`spades-deal-fly spades-deal-fly--${dealFlash.visualSeat}`}
        />
      )}

      {trickCards.length > 0 && (
        <div className="spades-trick-area" aria-label="Current trick">
          {trickCards.map((sprite) => (
            <TrickCardSprite
              key={sprite.id}
              sprite={sprite}
              cardW={cardW}
              cardH={cardH}
              trickDist={trickDist}
              handReach={handReach}
              onFlyComplete={onFlyComplete}
              onGatherComplete={onGatherComplete}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default SpadesCenter;
